// Renders the small inline content-block language used by guide article
// data files: plain paragraphs, lists, and callout boxes, with a simple
// [label](url) inline-link syntax so content stays plain data, not JSX.

import ServiceHistoryRegForm from "./ServiceHistoryRegForm";

const linkPattern = /\[([^\]]+)\]\(([^)]+)\)/g;

export function renderInline(text) {
  const parts = [];
  let lastIndex = 0;
  let match;
  let key = 0;
  linkPattern.lastIndex = 0;
  while ((match = linkPattern.exec(text))) {
    if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index));
    const [, label, href] = match;
    const external = /^https?:\/\//.test(href);
    parts.push(
      <a key={key++} href={href} rel={external ? "noopener" : undefined}>
        {label}
      </a>,
    );
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
}

export function GuideBlock({ block }) {
  if (block.type === "p") return <p>{renderInline(block.text)}</p>;
  if (block.type === "reg-form") return <ServiceHistoryRegForm brandKey={block.brand} heading={block.heading} />;
  if (block.type === "ul") {
    return (
      <ul>
        {block.items.map((item, i) => (
          <li key={i}>{typeof item === "string" ? renderInline(item) : <><strong>{item.strong}</strong> {renderInline(item.text)}</>}</li>
        ))}
      </ul>
    );
  }
  if (block.type === "ol") {
    return (
      <ol>
        {block.items.map((item, i) => (
          <li key={i}>{renderInline(item)}</li>
        ))}
      </ol>
    );
  }
  if (block.type === "callout") {
    return (
      <div className={`callout callout-${block.tone || "tip"}`}>
        <span className="callout-icon" aria-hidden="true">{block.tone === "note" ? "⚠️" : "💡"}</span>
        <div>
          {block.title && <strong>{block.title}</strong>}
          <p>{renderInline(block.text)}</p>
        </div>
      </div>
    );
  }
  if (block.type === "table") {
    return (
      <div className="guide-table-wrap">
        <table className="guide-table">
          {block.caption && <caption>{block.caption}</caption>}
          <thead><tr>{block.columns.map((col, i) => <th key={i} scope="col">{col}</th>)}</tr></thead>
          <tbody>
            {block.rows.map((row, i) => (
              <tr key={i}>{row.map((cell, j) => <td key={j}>{renderInline(cell)}</td>)}</tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  return null;
}
